// let klevu_js_key;
// import('{{ 'etempa-klevu-js-key.js' | asset_url }}')
// .then((module) => {
//     klevu_js_key = module;
// });

const klevu_js_key = 'klevu-163067900222714176';
const no_results_elem = document.getElementById('etempa-product-grid-no-results');
const error_elem = document.getElementById('etempa-product-grid-error');
const error_text_elem = document.getElementById('etempa-product-grid-error-text');
const product_grid_container = document.querySelector('.productgrid--wrapper');
const product_grid_ul = document.querySelector('.productgrid--items');
const pagination_container = document.querySelector('.pagination--container');
const pagination_previous = document.querySelector('.pagination--previous');
const pagination_next = document.querySelector('.pagination--next');
const pagination_items = document.getElementById('etempa-collection-pagination-pages');
const show_by_items = document.querySelectorAll('.utils-showby-item');
const filter_form = document.querySelector('.filter-form');
const sortBySelect = document.querySelector('[data-productgrid-trigger-sort]');
const mobile_filter_button = document.querySelector('.utils-filter-button');
const mobile_filter_text = mobile_filter_button.querySelector('.utils-filter-text');
const priceData = {};
const filterMinMaxData = {};
const product_items = [];

const sort_klevu_equivs = {
    'manual': 'RELEVANCE',
    'title-ascending': 'NAME_ASC',
    'title-descending': 'NAME_DESC',
    'price-ascending': 'PRICE_ASC',
    'price-descending': 'PRICE_DESC',
    'created-ascending': 'NEW_ARRIVAL_ASC',
    'created-descending': 'NEW_ARRIVAL_DESC'
};

let page = 1;
let limit = 36;
let view = 'grid-view';
let sort = 'manual';
let enabledFilters = [];
let currentFilters = [];

let priceRange = [];
let conditionsLength = 0;
let step;
let priceSlider;
let priceSliderContainer;
let hasEllipsisBefore = false;
let hasEllipsisAfter = false;
let currencySymbol = '£';
let changeCurrency = false;
let modalFirstGroupHeightInterval;
let urlParams = new URLSearchParams(document.location.search);
if (urlParams.get("page")) page = Number(urlParams.get("page"));
if (urlParams.get("grid_list")) view = urlParams.get("grid_list");
if (urlParams.get("view")) limit = Number(urlParams.get("view").replace('view-', ''));
if (urlParams.get("sort_by")) sort = urlParams.get("sort_by");
currentFilters = urlParams.getAll('filter');

let cachedFilters = localStorage.getItem('klevuCollectionCachedFilters') != undefined ? JSON.parse(localStorage.getItem('klevuCollectionCachedFilters')) : {};
let lastInteraction = localStorage.getItem('klevuCollectionCachedInteraction');

if(cachedFilters?.collection_name != collection_name || currentFilters.length < 1){
    cachedFilters = {}
    localStorage.removeItem('klevuCollectionCachedFilters');
    localStorage.removeItem('klevuCollectionCachedInteraction');
    lastInteraction = undefined;
}
cachedFilters.collection_name = collection_name;
console.log('cachedFilters', cachedFilters)

// console.log(collection_handle);
// console.log(collection_id);
// console.log(current_currency);
// console.log('page: ', page);
// console.log('view: ', view);
// console.log('limit: ', limit);
// console.log('sort: ', sort);
// console.log('currentFilters: ', currentFilters);

getProducts(collection_name, klevu_js_key);
setShowValue();
mobileFilterButtonEvent();
windowResizeEvent();
setupSortBySelectChangeEvent();


function setupSortBySelectChangeEvent(){
    if(sortBySelect){
        sortBySelect.addEventListener('change', e =>{
            e.preventDefault();
            sort = sortBySelect.value;
            window.location.href = buildHref(1);
        })
    }
}

function getProducts(collection_name, klevu_js_key) {
    no_results_elem.style.display = 'none';
    error_elem.style.display = 'none';

    let request = {
        recordQueries: [
            {
                filters:{
                    filtersToReturn:{
                        enabled: true,
                        exclude: [
                            'variantid',
                            'inventoryQuantity',
                            'artist'
                        ],
                        options: {
                            order: "INDEX",
                            limit: 999999
                        },
                        rangeFilterSettings: [{
                            key: "klevu_price",
                            minMax: true,
                            rangeInterval: 10
                            
                        }]
                    }
                },
                id: "categoryProducts",
                typeOfRequest: "CATNAV",
                settings: {
                    sort: sort_klevu_equivs[sort],
                    query: {
                        categoryPath: collection_name
                    },
                    limit: limit,
                    offset: page > 1 ? limit * (page - 1) : 0,
                    groupCondition: {}
                }
            }
        ],
        context: {
            apiKeys: [klevu_js_key]
        }
    }

  //console.log('HERE');
  //console.log(request);

    if (currentFilters.length > 0) {
        request.recordQueries[0].settings.groupCondition = {
            groupOperator: "ALL_OF",
            conditions: []
        };

        currentFilters.forEach((filter)=>{
            let filterArray = filter.split('_');
            let filterKey = filterArray[0];
            let filterValue = decodeURIComponent(filterArray[1]);

            if (filterKey === 'minMaxPrice') {
                let filterMin = Number(filterArray[1]);
                let filterMax = Number(filterArray[2]);
                if (changeCurrency) {
                    fetch(`/?params=${filterMin}_${filterMax}&sections=etempa-minmax-currency-conversion`, {
                        method: 'GET',
                        // mode: 'cors',
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(filterSectionResponse => filterSectionResponse.json())
                    .then(filterSectionData => {
                        // console.log(filterSectionData);
                        let tempElem = document.createElement('div');
                        tempElem.innerHTML = filterSectionData['etempa-minmax-currency-conversion'];
                        let filterInfoElem = tempElem.querySelector('.currency-conversion-filter-info');
                        if (filterInfoElem) {
                            filterMin = Number(filterInfoElem.getAttribute('data-filter-min').trim());
                            filterMax = Number(filterInfoElem.getAttribute('data-filter-max').trim());

                            request.recordQueries[0].settings.groupCondition.conditions.push({
                                key: "klevu_price",
                                valueOperator: "INCLUDE",
                                singleSelect: false,
                                values: [
                                    filterMin,
                                    filterMax
                                ]
                            });

                            conditionsLength++;
                        }
                    })
                    .catch(error => {
                        console.error(error);
                        error_elem.style.display = 'block';
                        error_text_elem.innerText = error;
                    });
                }
                else {
                    request.recordQueries[0].settings.groupCondition.conditions.push({
                        key: "klevu_price",
                        valueOperator: "INCLUDE",
                        singleSelect: false,
                        values: [
                            filterMin,
                            filterMax
                        ]
                    });
                    conditionsLength++;
                }
            }
            else {
                let conditionExistsIndex = request.recordQueries[0].settings.groupCondition.conditions.findIndex(condition => condition.key === filterKey);
                if (conditionExistsIndex > -1) {
                    request.recordQueries[0].settings.groupCondition.conditions[conditionExistsIndex].values.push(filterValue);
                }
                else {
                    request.recordQueries[0].settings.groupCondition.conditions.push({
                        key: filterKey,
                        valueOperator: "INCLUDE",
                        singleSelect: false,
                        values: [
                            filterValue
                        ]
                    });
                }
                conditionsLength++;
            }
        });
    }

    if (currentFilters.length > 0) {
        const runQuery = setInterval(()=>{
            if (conditionsLength === currentFilters.length) {
                clearInterval(runQuery);
                runKlevuQuery(request);
            }
        }, 500, request, currentFilters);
    }
    else {
        runKlevuQuery(request);
    }
}

function runKlevuQuery(request) {
    console.log('klevu request', request);
     // get all filters for current collection
    // this is quite wasteful


    fetch(`https://rwcsv2.ksearchnet.com/cs/v2/search`, {
        method: 'POST',
        // mode: 'cors',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(request)
    })
    .then(response => response.json())
    .then(data => {
        console.log('klevuData', data);
        if (data.meta.responseCode === 200) {
            
            if (data.queryResults[0]?.meta.noOfResults > 0 &&  data.queryResults[0].records.length > 0) {
                const allHandles = data.queryResults[0].records.map(record => record.url.split('/').pop());
                const handles = arrayChunk(allHandles, 20);
                
                if (current_currency !== 'GBP') {
                    changeCurrency = true;
                    let filterMax = 0;
                    let filterMin = 0;
                    data.queryResults[0].filters.forEach((filter)=>{
                        if (filter.key === 'klevu_price') {
                            filterMax = filter.max;
                            filterMin = filter.min;
                        }
                    });

                    handles.forEach((handleChunk, index) => {
                        fetch(`/?handles=${handleChunk.join('_')}&sections=etempa-currency-conversion&max=${filterMax}&min=${filterMin}`, {
                            method: 'GET',
                            // mode: 'cors',
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                        .then(sectionResponse => sectionResponse.json())
                        .then(sectionData => {
                            // console.log(sectionData);
                            let tempElem = document.createElement('div');
                            tempElem.innerHTML = sectionData['etempa-currency-conversion'];
                            let priceInfoArray = tempElem.querySelectorAll('.currency-conversion-price-info');
                            let filterInfoElem = tempElem.querySelector('.currency-conversion-filter-info');
                            if (priceInfoArray && priceInfoArray.length > 0) {
                                currencySymbol = priceInfoArray[0].getAttribute('data-product-price')[0];
                                priceInfoArray.forEach((priceInfo)=>{
                                    priceData[parseInt(priceInfo.getAttribute('data-product-id').trim())] = {
                                        price: priceInfo.getAttribute('data-product-price'),
                                        comparePrice: priceInfo.getAttribute('data-product-compare-price')
                                    }
                                });
                            }
                            // console.log(priceData);
                            if (filterInfoElem) {
                                filterMinMaxData.max = Number(filterInfoElem.getAttribute('data-filter-max').trim());
                                filterMinMaxData.min = Number(filterInfoElem.getAttribute('data-filter-min').trim());
                            }
                        })
                        .catch(error => {
                            console.error(error);
                            error_elem.style.display = 'block';
                            error_text_elem.innerText = error;
                        });
                    });
                    const displayPriceData = setInterval(()=>{
                        if (Object.keys(priceData).length === allHandles.length) {
                            clearInterval(displayPriceData);
                            constructProductsAndFilters(data);
                        }
                    }, 500, priceData, allHandles, data);
                }
                else {
                    constructProductsAndFilters(data);
                }

                if (data.queryResults[0]?.meta.noOfResults != data.queryResults[0]?.meta.totalResultsFound) {
                    buildPagination(data.queryResults[0].meta.totalResultsFound);
                }
                else {
                    pagination_container.style.display = 'none';
                }
            }
            else {
                no_results_elem.style.display = 'block';
                pagination_container.style.display = 'none';
            }
        }
        else {
            error_elem.style.display = 'block';
            error_text_elem.innerText = 'Sorry something has gone wrong, please refresh the page and try again';
        }
    })
    .catch(error => {
        console.error(error);
        error_elem.style.display = 'block';
        error_text_elem.innerText = error;
    });
}

function constructProductsAndFilters(data) {
    data.queryResults[0].records.forEach((product)=>{
        buildProductCard(collection_name, collection_handle, product);
    });

    enabledFilters = data.queryResults[0]?.filters;

    let tmpCachedFilterArray = [];
    enabledFilters = data.queryResults[0]?.filters;
    if (enabledFilters && Array.isArray(enabledFilters) && enabledFilters.length > 0) {
        enabledFilters.forEach((filter, index)=>{
            filtersToCache = buildFilterBlock(filter, index);
            if(filtersToCache != null){
                tmpCachedFilterArray.push(filtersToCache);
            }
        });
        cachedFilters.filters = [...tmpCachedFilterArray];
        localStorage.setItem('klevuCollectionCachedFilters', JSON.stringify(cachedFilters));
        createActiveFilters();
    }

}

function buildProductCard(collection_name, collection_handle, product) {

    let link = `/collections/${collection_name}/products/${product.url.split('/').pop()}`;
    let price = Number(product.salePrice);
    let comparePrice = Number(product.price);
    let onSale = price < comparePrice ? true : false;
    let discount;
    let imageUrl = product.imageUrl;
    let imageUrlTemplate = '';
    let preOrder = product.tags?.search('Pre-Order') >= 0 ? true : false;
    let inStock = true;
    if (product.inStock == 'no' || product.inventoryQuantity === 0){
        inStock = false;
    }

    if (onSale) {
        discount = Math.ceil(100 * (comparePrice - price) / comparePrice);
    }

    if (imageUrl) {
        let imageUrlSplit = imageUrl.split('.');
        let imageUrlExtension = imageUrlSplit.pop();
        imageUrlTemplate = `${imageUrlSplit.join('.')}_{size}.${imageUrlExtension}`;
    }

    let li = document.createElement('li');
    li.classList.add('productgrid--item','imagestyle--medium','productitem--emphasis','show-actions--mobile');
    li.setAttribute('data-product-item','');
    li.setAttribute('data-product-quickshop-url', collection_handle);

    let productItem = document.createElement('div');
    productItem.classList.add('productitem');
    productItem.setAttribute('data-product-item-content','');
    li.append(productItem);

    let productItemContainer = document.createElement('div');
    productItemContainer.classList.add('productitem__container');
    productItem.append(productItemContainer);

    /** image */

    let productItemImageContainer = document.createElement('div');
    productItemImageContainer.classList.add('productitem__image-container');
    productItemContainer.append(productItemImageContainer);

    let productItemImageLink = document.createElement('a');
    productItemImageLink.classList.add('productitem--image-link');
    productItemImageLink.setAttribute('href', link);
    productItemImageLink.setAttribute('tabindex', -1);
    productItemImageLink.setAttribute('data-product-page-link','');
    // productItemImageLink.setAttribute('data-appmate','');
    productItemImageContainer.append(productItemImageLink);

    let productItemImage = document.createElement('figure');
    productItemImage.classList.add('productitem--image');
    productItemImage.setAttribute('data-product-item-image', '');
    productItemImageLink.append(productItemImage);

    let productImage = document.createElement('img');
    productImage.onload = function() {
        productImage.style.visibility = 'visible';
        productImage.nextElementSibling.style.visibility = 'hidden';
    };
    productImage.setAttribute('src', imageUrl);
    productImage.setAttribute('data-rimg', 'lazy');
    productImage.setAttribute('data-rimg-scale', 1);
    productImage.setAttribute('data-rimg-template', imageUrlTemplate);
    productImage.setAttribute('data-rimg-max', '185.5x185.5');
    productImage.setAttribute('width', 185.5);
    productImage.setAttribute('height', 185.5);
    productImage.setAttribute('data-rimg-crop', false);
    productImage.setAttribute('srcset', imageUrl);
    productImage.setAttribute('data-rimg-template-svg', `data:image/svg+xml;utf8,<svg%20xmlns='http://www.w3.org/2000/svg'%20width='512'%20height='636'></svg>`);
    productItemImage.append(productImage);

    let dataRimgCanvas = document.createElement('div');
    dataRimgCanvas.setAttribute('data-rimg-canvas','');
    productItemImage.append(dataRimgCanvas);

    let productItemSaleBadge;
    if (onSale) {
        productItemSaleBadge = document.createElement('span');
        productItemSaleBadge.classList.add('productitem__badge', 'productitem__badge--sale');
        productItemSaleBadge.setAttribute('data-badge-sales', '');
        productItemSaleBadge.innerHTML = `<span data-badge-sales-range="">Save <span data-price-percent-saved="">${discount}</span>%</span>`;
        productItemImage.append(productItemSaleBadge);
    }

    if (preOrder) {
        let preOrderBadge = document.createElement('span');
        preOrderBadge.innerHTML = `<span class="preorder-badge">Pre-Order</span>`;
        productItemImage.append(preOrderBadge);
    }
    if(!inStock){
        let soldOutBadge = document.createElement('span');
        soldOutBadge.innerHTML = `<span class="soldout-badge">Sold Out</span>`;
        productItemImage.append(soldOutBadge);
    }

    /** info */

    let productItemInfo = document.createElement('div');
    productItemInfo.classList.add('productitem--info');
    productItemContainer.append(productItemInfo);

    let productItemPriceContainer = document.createElement('div');
    productItemPriceContainer.classList.add('price','productitem__price');
    productItemInfo.append(productItemPriceContainer);

    let compareAtPrice = document.createElement('div');
    compareAtPrice.classList.add('price__compare-at','visible');
    compareAtPrice.setAttribute('data-price-compare-container', '');
    productItemPriceContainer.append(compareAtPrice);

    let compareAtPriceSpan = document.createElement('span');
    compareAtPriceSpan.classList.add('money','price__original');
    compareAtPriceSpan.setAttribute('data-price-original','');
    if (onSale) compareAtPriceSpan.innerText = changeCurrency ? priceData[product.id]?.comparePrice :`£${comparePrice.toFixed(2)}`;
    compareAtPrice.append(compareAtPriceSpan);

    let priceElem = document.createElement('div');
    priceElem.classList.add('price__current','price__current--emphasize');
    priceElem.setAttribute('data-price-container', '');
    productItemPriceContainer.append(priceElem);

    let priceSpan = document.createElement('span');
    priceSpan.classList.add('money');
    priceSpan.setAttribute('data-price','');
    priceSpan.innerText = changeCurrency ? priceData[product.id]?.price : `£${price.toFixed(2)}`;
    priceElem.append(priceSpan);

    let productItemType = document.createElement('div');
    productItemType.classList.add('wrap_');
    productItemType.innerText = product.type;
    productItemInfo.append(productItemType);

    let productItemTitle = document.createElement('h2');
    productItemTitle.classList.add('productitem--title');
    productItemInfo.append(productItemTitle);

    let productItemTitleLink = document.createElement('a');
    productItemTitleLink.setAttribute('href', link);
    productItemTitleLink.setAttribute('data-product-page-link','');
    productItemTitleLink.innerText = product.name;
    productItemTitle.append(productItemTitleLink);

    if (product.artist && product.artist != '') {
        let highlightMetafield = document.createElement('div');
        highlightMetafield.classList.add('metafield_');
        // wuick fix for metafield
        if(product.artist.startsWith('[') && product.artist.endsWith(']')){
            highlightMetafield.innerText = product.artist.slice(1, product.artist.length -1);
        }
        else{
            highlightMetafield.innerText = product.artist;

        }
        productItemInfo.append(highlightMetafield);
    }

    let productItemStockLevel = document.createElement('div');
    productItemStockLevel.classList.add('productitem__stock-level');
    productItemInfo.append(productItemStockLevel);

    let productItemStockLevelWrapper = document.createElement('div');
    productItemStockLevelWrapper.classList.add('product-stock-level-wrapper');
    productItemStockLevel.append(productItemStockLevelWrapper);

    if (product.inventoryQuantity && inStock) {
        let stockLevelNumber = Number(product.inventoryQuantity);
        let stockLevelClassName = 'product-stock-level--high',
            stockLevelText = 'Available';
        if (stockLevelNumber < 5) {
            stockLevelClassName = 'product-stock-level--low';
            stockLevelText = 'Low stock';
        }
        let productItemStockLevelSpan = document.createElement('span');
        productItemStockLevelSpan.classList.add('product-stock-levels', stockLevelClassName);
        productItemStockLevelSpan.innerHTML = `<span class="product-stock-level__text"><div class="product-stock-level__badge-text">${stockLevelText}</div></span>`;
        productItemStockLevelWrapper.append(productItemStockLevelSpan);
    }

    let productItemDescrition = document.createElement('div');
    productItemDescrition.classList.add('productitem--description');
    productItemInfo.append(productItemDescrition);

    if (product.shortDesc) {
        let descriptionPara = document.createElement('p');
        descriptionPara.innerText = product.shortDesc;
        productItemDescrition.append(descriptionPara);
    }

    let descriptionLink = document.createElement('a');
    descriptionLink.classList.add('productitem--link');
    descriptionLink.setAttribute('data-product-page-link','');
    descriptionLink.setAttribute('href', link);
    descriptionLink.innerText = 'View full details';
    productItemDescrition.append(descriptionLink);

    let productItemActions = document.createElement('div');
    productItemActions.classList.add('productitem--actions');
    productItemActions.setAttribute('data-product-actions','');
    productItemContainer.append(productItemActions);

    let productItemListViewPrice = document.createElement('div');
    productItemListViewPrice.classList.add('productitem--listview-price');
    productItemActions.append(productItemListViewPrice);

    let productItemListViewPriceInner = productItemPriceContainer.cloneNode(true);
    productItemListViewPrice.append(productItemListViewPriceInner);

    if (onSale) {
        let productItemListViewBadge = document.createElement('div');
        productItemListViewBadge.classList.add('productitem--listview-badge');
        productItemActions.append(productItemListViewBadge);

        let productItemListViewBadgeInner = productItemSaleBadge.cloneNode(true);
        productItemListViewBadge.append(productItemListViewBadgeInner);
    }

    let productATCButton = document.createElement('div');
    productATCButton.classList.add('productitem--action','atc--button');
    productItemActions.append(productATCButton);

    let productButton = document.createElement('button');
    let productButtonText = preOrder ? 'Pre-Order' : 'Add to basket';
    productButton.classList.add('productitem--action-trigger','productitem--action-atc','button-primary','mdc-ripple-surface','mdc-ripple-upgraded');
    productButton.setAttribute('type', 'button');
    if(!inStock){
        productButtonText = 'Sold Out';
        productButton.classList.add('disabled');
        productButton.setAttribute('disabled', 'true');
    }
    else{
        if (preOrder) productButton.classList.add('preorder-button');
        productButton.setAttribute('data-quick-buy', '');
        productButton.setAttribute('data-variant-id', Number(product.variantid));
    }
    
    productButton.setAttribute('aria-label', productButtonText);
    productButton.addEventListener('click',(e)=>{console.log('click');});
    productButton.innerHTML = `<span class=\"atc-button--text\">${productButtonText}</span>`;
    if(inStock){
        productButton.innerHTML += `<span class=\"atc-button--icon\"><svg aria-hidden=\"true\" focusable=\"false\" role=\"presentation\" width=\"26\" height=\"26\" viewBox=\"0 0 26 26\" xmlns=\"http://www.w3.org/2000/svg\">\n  <g fill-rule=\"nonzero\" fill=\"currentColor\">\n    <path d=\"M13 26C5.82 26 0 20.18 0 13S5.82 0 13 0s13 5.82 13 13-5.82 13-13 13zm0-3.852a9.148 9.148 0 1 0 0-18.296 9.148 9.148 0 0 0 0 18.296z\" opacity=\".29\"></path><path d=\"M13 26c7.18 0 13-5.82 13-13a1.926 1.926 0 0 0-3.852 0A9.148 9.148 0 0 1 13 22.148 1.926 1.926 0 0 0 13 26z\"></path>\n  </g>\n</svg></span>`;
    }
    productATCButton.append(productButton);

    /** klevu scripts */

    let klevuQuickBuyScript = document.createElement('script');
    klevuQuickBuyScript.setAttribute('type','application/json');
    klevuQuickBuyScript.setAttribute('data-quick-buy-settings', '');
    klevuQuickBuyScript.innerHTML = `{
        "cart_redirection": false,
        "money_format": "${currencySymbol}\{\{amount\}\}"
    }`;
    li.append(klevuQuickBuyScript);

    let klevuPLCollectionScript = document.createElement('script');
    klevuPLCollectionScript.setAttribute('type','text/javascript');
    klevuPLCollectionScript.innerHTML = `
        if (typeof klevuProducts == 'undefined') {
            var klevuProducts = new Array();
        }
        
        klevuProducts.push(${Number(product.id)});
    `;
    li.append(klevuPLCollectionScript);

    /** create */
    product_grid_ul.append(li);
    // product_items.push(new ProductGridItem({
    //     el: li,
    //     id: collection_section_id,
    //     lazy: true,
    //     grid_list: view
    // }));
}

function buildPagination(totalResultsFound) {
    numberOfPages = Math.ceil(totalResultsFound / limit);
    if (numberOfPages > 1) {
        for (let pageCounter = 1; pageCounter <= numberOfPages; pageCounter++) {
            let paginationLi = document.createElement('li');
            let paginationItem;
            if (pageCounter === 1 || (pageCounter >= page - 2 && pageCounter <= page + 2 ) || pageCounter === numberOfPages) {
                if (pageCounter === page) {
                    paginationLi.classList.add('pagination--active');
                    paginationLi.setAttribute('aria-label', `Page ${pageCounter}`);
                    paginationLi.setAttribute('aria-current', true);
                    paginationItem = document.createElement('span');
                }
                else {
                    paginationItem = document.createElement('a');
                    paginationItem.setAttribute('href', buildHref(pageCounter));
                }
                paginationItem.classList.add('pagination--item');
                paginationItem.innerText = pageCounter;
                paginationLi.append(paginationItem);
                pagination_items.append(paginationLi);
            }
            else if (pageCounter < page - 2 && !hasEllipsisBefore) {
                addEllipsis(paginationLi, paginationItem, true);
            }
            else if (pageCounter > page + 2 && !hasEllipsisAfter) {
                addEllipsis(paginationLi, paginationItem, false);
            }
        }

        if (page === 1) {
            pagination_previous.style.display = 'none';
        }
        else {
            pagination_previous.querySelector('.pagination--item').setAttribute('href', buildHref(page - 1))
        }

        if (page === numberOfPages) {
            pagination_next.style.display = 'none';
        }
        else {
            pagination_next.querySelector('.pagination--item').setAttribute('href', buildHref(page + 1))
        }
    }
    else {
        pagination_container.style.opacity = 0;
    }
}

function addEllipsis(paginationLi, paginationItem, before) {
    paginationLi.classList.add('pagination--ellipsis');
    paginationItem = document.createElement('span');
    paginationItem.classList.add('pagination--item');
    paginationItem.innerText = '...';
    paginationLi.append(paginationItem);
    pagination_items.append(paginationLi);
    before ? hasEllipsisBefore = true : hasEllipsisAfter = true;
}

function setShowValue() {
    show_by_items.forEach((item)=>{
        if (Number(item.getAttribute('data-show-by')) === limit) {
            item.classList.add('utils-showby-item--active');
        }
        else {
            item.classList.remove('utils-showby-item--active');
        }
        if (currentFilters.length > 0) {
            let params = new URLSearchParams();
            currentFilters.forEach((filter)=>{ params.append('filter', filter) });
            item.setAttribute('href', `${item.getAttribute('href')}&${params.toString()}`);
        }
    });
}

/** filter functions */

function buildFilterBlock(filter, index) {
    let lastSelectedFilterKey = lastInteraction != undefined ? lastInteraction : null;

    let tmpCachedFilters = null;

    let activeGroup = window.location.href.search(`=${filter.key}_`) > -1 ? true : false;
    let filterGroup = document.createElement('div');
    filterGroup.classList.add('collection-filters__filter-group');
    filterGroup.setAttribute('aria-label', 'Filters');
    filterGroup.setAttribute('data-filter-group','');
    filter_form.append(filterGroup);

    let filterGroupButton = document.createElement('div');
    filterGroupButton.classList.add('collection-filters__filter-group-heading', 'productgrid--sidebar-button');
    if (index === 0 || activeGroup) filterGroupButton.classList.add('productgrid--sidebar-button-active');
    filterGroupButton.setAttribute('data-filter-group-trigger', '');
    filterGroupButton.setAttribute('aria-expanded', index === 0 ? true : false);
    filterGroupButton.innerHTML = `<div class="collection-filters__filter-title">${filter.label === 'klevu_price' ? 'Price' : filter.label}</div><div class="collection-filters__filter-icon-wrapper" tabindex="-1"> <span class="collection-filters__filter-icon"> <svg aria-hidden="true" focusable="false" role="presentation" width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-chevron-down"><path class="icon-chevron-down-left" d="M4 4.5L7 1.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="square"></path><path class="icon-chevron-down-right" d="M4 4.5L1 1.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="square"></path></svg> </span> </div>`
    filterGroupButton.addEventListener('click', filterGroupButtonClick);
    filterGroup.append(filterGroupButton);

    let filterGroupList = document.createElement('ul');
    filterGroupList.classList.add('collection-filters__filter', 'collection-filters__filter-list');
    filterGroupList.setAttribute('data-filter-group-list','');
    filterGroup.append(filterGroupList);

    if (filter.key === 'klevu_price') {
        tmpCachedFilters = filter;
        priceSliderContainer = document.createElement('div');
        priceSliderContainer.classList.add('etempa-price-slider-container');
        filterGroupList.append(priceSliderContainer);

        let priceFilter = document.createElement('input');
        priceFilter.setAttribute('id', 'etempa-filter-price-slider');
        priceFilter.classList.add('etempa-filter-price-slider');
        priceSliderContainer.append(priceFilter);

        let filterMin = changeCurrency ? Number(filterMinMaxData.min) : Number(filter.min);
        let filterMax = changeCurrency ? Number(filterMinMaxData.max) : Number(filter.max);

        if (filterMax <= 50) {
            step = 10;
        }
        else if (filterMax <= 150) {
            step = 20;
        }
        else {
            step = 50;
        }

        let minPrice = Math.floor(filterMin / step) * step;
        let maxPrice = Math.ceil(filterMax / step) * step;
        priceRange = [];

        for (let price = minPrice; price <= maxPrice; price += step) {
            priceRange.push(price);
        }

        buildPriceSlider();
    }
    else {
        let enabledFilterOptions = [...filter.options];
        if(lastSelectedFilterKey == filter.key){
            let cachedEnabledFilter = cachedFilters.filters?.find(f => f.key == filter.key);
            if(cachedEnabledFilter){
                enabledFilterOptions = [...cachedEnabledFilter.options];
                tmpCachedFilters = cachedEnabledFilter;
            }
            else{
                enabledFilterOptions = [...filter.options];
                tmpCachedFilters = filter;
            }
        }
        else{
            tmpCachedFilters = filter;
        }
        //check to see if there are any 'enabled' filters that aren't returned by Klevu
        let enabledFiltersNotInDataset = [];
        currentFilters.forEach(currentFilter => {
            let filterArray = currentFilter.split('_');
            let filterKey = filterArray[0];
            let filterValue = decodeURIComponent(filterArray[1]);
            if(filterKey == filter.key){
                if(enabledFilterOptions.find(f => f.value === filterValue) === undefined){
                    enabledFiltersNotInDataset.push({value: filterValue});
                }
            }
        })
        enabledFilterOptions.push(...enabledFiltersNotInDataset)
        if (enabledFilterOptions && Array.isArray(enabledFilterOptions) && enabledFilterOptions.length > 0) {
            
            let filterOptionsContainer = document.createElement('div');
            filterOptionsContainer.classList.add('etempa-filter-options-container');
            filterGroupList.append(filterOptionsContainer);

            let loopLimit =  enabledFilterOptions.length;
            if ( enabledFilterOptions.length > 25) {
                loopLimit = 25;

                let searchResultContainer = document.createElement('div');
                searchResultContainer.classList.add('etempa-filter-search-results-container');
                filterGroupList.append(searchResultContainer);

                let filterOptionSearch = document.createElement('input');
                filterOptionSearch.setAttribute('type','text');
                filterOptionSearch.classList.add('etempa-filter-option-search');
                filterOptionSearch.setAttribute('data-filter-key', filter.key);
                filterOptionSearch.setAttribute('placeholder', 'search...');
                filterOptionSearch.addEventListener('keyup', filterOptionSearchChange);
                filterGroupList.insertBefore(filterOptionSearch, filterOptionsContainer);

                let filterOptionsOverflow = document.createElement('li');
                filterOptionsOverflow.classList.add('collection-filters__filter-list-item','collection-filters__filter-list-item-text','etempa-filter-option-overflow');
                filterOptionsOverflow.innerText = '...';
                filterGroupList.append(filterOptionsOverflow);
            }
            for (let optionIndex = 0; optionIndex < loopLimit; optionIndex ++) {
                
                populateOptions(filter.key, enabledFilterOptions[optionIndex].value, filterOptionsContainer);
            }

            if (index === 0 || activeGroup) {
                filterGroupList.classList.add('filter-group-active');
                filterGroupList.style.height = `${getHiddenHeight(filterGroupList)}px`;
            }
        }
    }
    return tmpCachedFilters;
}

function populateOptions(filterKey, optionValue, filterOptionsContainer) {
    let activeFilter = currentFilters.includes(`${filterKey}_${encodeURIComponent(optionValue)}`) ? true : false;
    let filterOption = document.createElement('li');
    filterOption.classList.add('collection-filters__filter-list-item');
    if (activeFilter) filterOption.classList.add('collection-filters__filter-list-item--active');
    filterOption.setAttribute('data-filter-open', activeFilter);
    filterOption.setAttribute('data-filter-key', filterKey);
    filterOption.setAttribute('data-filter-value', optionValue);
    filterOption.addEventListener('click', filterOptionClick);
    filterOptionsContainer.append(filterOption);

    let filterOptionLink = document.createElement('a');
    filterOptionLink.classList.add('collection-filters__filter-link');
    filterOptionLink.setAttribute('data-filter-input','');
    if (activeFilter) filterOptionLink.setAttribute('data-filter-active', '');
    filterOptionLink.innerHTML = `<span class="filter-icon--checkbox" data-handle="filter-Product-type-0">`;
    filterOptionLink.innerHTML += `<svg class="checkmark" aria-hidden="true" focusable="false" role="presentation" width="14" height="14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" data-animation-state="${activeFilter ? 'checked' : 'unchecked'}"><path class="checkmark__check" fill="none" d="M2.5 7L5.5 10L11.5 4" data-animation-state="${activeFilter ? 'checked' : 'unchecked'}"></path>`;
    filterOptionLink.innerHTML += `</svg></span> <span class="collection-filters__filter-list-item-text">${optionValue}</span>`;
    filterOption.append(filterOptionLink);
}

function filterGroupButtonClick() {
    let _thisul = this.parentElement.querySelector('.collection-filters__filter-list');
    if (this.classList.contains('productgrid--sidebar-button-active')) {
        this.classList.remove('productgrid--sidebar-button-active'); 
        _thisul.classList.remove('filter-group-active');
        _thisul.style.height = 0;
    }
    else {
        this.classList.add('productgrid--sidebar-button-active');
        this.setAttribute('aria-expanded', true);
        _thisul.classList.add('filter-group-active');
        _thisul.style.height = `${getHiddenHeight(_thisul)}px`;
    }
}

function filterOptionClick(e) {
    e.preventDefault();
    // prevent selection of multiple filters at the same time
    if(filter_form.classList.contains('loading')) return
    filter_form.classList.add('loading')
    if (window.innerWidth < 860) showLoadingSpinner();
    let _thislink = this.querySelector('.collection-filters__filter-link');
    let _thissvg = _thislink.querySelector('.checkmark');
    let _thispath = _thislink.querySelector('.checkmark__check');
    let filterKey = this.getAttribute('data-filter-key');
    let filterValue = this.getAttribute('data-filter-value');
    if (this.classList.contains('collection-filters__filter-list-item--active')) {
        this.classList.remove('collection-filters__filter-list-item--active');
        this.setAttribute('data-filter-open', false);
        _thislink.removeAttribute('data-filter-active', '');
        _thissvg.setAttribute('data-animation-state','unchecked');
        _thispath.setAttribute('data-animation-state','unchecked');
        let target = `${filterKey}_${encodeURIComponent(filterValue)}`;
        currentFilters = currentFilters.filter(item => item !== target);
    }
    else {
        this.classList.add('collection-filters__filter-list-item--active');
        this.setAttribute('data-filter-open', true);
        _thislink.setAttribute('data-filter-active', '');
        _thissvg.setAttribute('data-animation-state','checked');
        _thispath.setAttribute('data-animation-state','checked');
        currentFilters.push(`${filterKey}_${encodeURIComponent(filterValue)}`);
    }
    // console.log(currentFilters);
    localStorage.setItem('klevuCollectionCachedInteraction', filterKey);
    window.location.href = buildHref(1);
}

function showLoadingSpinner() {
    let spinnerContainer = document.createElement('div');
    spinnerContainer.classList.add('mobile-modal-spinner');
    spinnerContainer.style.position = 'fixed';
    spinnerContainer.style.width = '100%';
    spinnerContainer.style.height = '100vh';
    spinnerContainer.style.top = 0;
    spinnerContainer.style.left = 0;
    spinnerContainer.style.display = 'grid';
    spinnerContainer.style.backgroundColor = 'rgba(255,255,255,0.8)';
    spinnerContainer.style.placeItems = 'center';
    spinnerContainer.style.zIndex = 999;
    spinnerContainer.innerHTML = `<?xml version="1.0" encoding="utf-8"?><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="104px" height="104px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><circle cx="50" cy="50" fill="none" stroke="#e5342e" stroke-width="1" r="35" stroke-dasharray="164.93361431346415 56.97787143782138"> <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform></circle></svg>`;
    
    document.querySelector('body').appendChild(spinnerContainer);
}

function buildPriceSlider() {
    priceSlider = new rSlider({
        target:   '#etempa-filter-price-slider',
        values:   priceRange,
        range:    true, // range slider
        set:      null, // an array of preselected values
        width:    priceSliderContainer.getBoundingClientRect().width - 30,
        scale:    true,
        labels:   true,
        tooltip:  false,
        step:     step, // step size
        disabled: false, // is disabled?
        onChange: sliderChange // callback
    });
}

function sliderChange(values) {
    if (sliderInteraction) { // check it has been interacted with, not just initially set
        if (window.innerWidth < 860) showLoadingSpinner();
        let valuesArray = values.split(',');
        let sliderMinMax = `minMaxPrice_${Number(valuesArray[0])}_${Number(valuesArray[1])}`;
        currentFilters = currentFilters.filter(item => item.includes('minMaxPrice') === false);
        currentFilters.push(sliderMinMax);
        // console.log(currentFilters);
        window.location.href = buildHref(1);
    }
}

function filterOptionSearchChange() {
    let lastSelectedFilterKey = lastInteraction != undefined ? lastInteraction : null;
    let search = this.value.toLowerCase().trim();
    let searchResult;
    let filterKey;
    // if (search) {
    //     filterKey = this.getAttribute('data-filter-key');
    //     let filterKeyIndex = enabledFilters.findIndex(item => item.key === filterKey);
    //     let count = 0;
    //     searchResult = enabledFilters[filterKeyIndex].options.filter((option) => {
    //         if (count < 25) {
    //             if (option.value.toLowerCase().search(search) >= 0) {
    //                 count++;
    //                 return option;
    //             }
    //         }
    //     });
    //     // console.log(searchResult);
    // }
    if (search) {
        filterKey = this.getAttribute('data-filter-key');
        let filterOptions = enabledFilters.find(item => item.key === filterKey).options;
        let enabledFilterOptions = [...filterOptions];
        if(lastSelectedFilterKey == filterKey){
            let cachedEnabledFilter = cachedFilters.filters?.find(f => f.key == filterKey);
            enabledFilterOptions = [...cachedEnabledFilter.options];
        }
       
        let count = 0;
        searchResult = enabledFilterOptions.filter((option) => {
            if (count < 25) {
                if (option.value.toLowerCase().search(search) >= 0) {
                    count++;
                    return option;
                }
            }
        });
        // console.log(searchResult);
    }

    let searchContainer = this.parentElement.querySelector('.etempa-filter-search-results-container');
    let optionsContainer = this.parentElement.querySelector('.etempa-filter-options-container');
    searchContainer.innerHTML = '';

    if (search) {
        optionsContainer.style.display = 'none';
        if (searchResult.length > 0) {
            searchResult.forEach(option => populateOptions(filterKey, option.value, searchContainer));
        }
    }
    else {
        optionsContainer.style.display = 'block';
    }
}

function getHiddenHeight(el) {
    if(!el?.cloneNode) {
        return null;
    }

    const clone = el.cloneNode(true);

    Object.assign(clone.style, {
        overflow: 'visible',
        height: 'auto',
        maxHeight: 'none',
        opacity: '0',
        visibility: 'hidden',
        display: 'block',
    });
    
    el.after(clone);
    const height = clone.offsetHeight;

    clone.remove();

    return height;
}

function buildHref(targetPage) {
    let params = new URLSearchParams();
    params.append('page', targetPage);
    params.append('view', limit);
    params.append('grid_list', view);
    params.append('sort_by', sort);
    if (currentFilters.length > 0) {
        currentFilters.forEach(filter => params.append('filter', filter));
    }
    let href = `/collections/${collection_handle}?${params.toString()}`;
    return href;
}

function createActiveFilters() {
    if (currentFilters.length > 0) {
        let activeFiltersContainer = document.createElement('div');
        activeFiltersContainer.classList.add('productgrid--filters');
        product_grid_container.insertBefore(activeFiltersContainer, product_grid_ul);

        let activeFilterGroup = document.createElement('ul');
        activeFilterGroup.classList.add('active-filter-group');
        activeFiltersContainer.append(activeFilterGroup);

        currentFilters.forEach((filter)=>{
            let filterArray = filter.split('_');
            let filterKey = filterArray[0];
            let filterValue = decodeURIComponent(filterArray[1]);

            let filterItem = document.createElement('li');
            filterItem.classList.add('active-filter-group__item-wrapper');
            filterItem.setAttribute('data-filter-key', filterKey);
            filterItem.setAttribute('data-filter-value', filterKey === 'minMaxPrice' ? `${filterValue}_${filterArray[2]}` : filterValue);
            filterItem.innerHTML = `<a class="active-filter-group__item" data-filter-input=""> <span class="active-filter-text">${filterKey === 'minMaxPrice' ? `Price: ${currencySymbol}${filterValue} - ${currencySymbol}${filterArray[2]}` : filterValue}</span><span class="filter-icon--remove"> <svg class="icon-remove " aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10"> <path fill="currentColor" d="M6.08785659,5 L9.77469752,1.31315906 L8.68684094,0.225302476 L5,3.91214341 L1.31315906,0.225302476 L0.225302476,1.31315906 L3.91214341,5 L0.225302476,8.68684094 L1.31315906,9.77469752 L5,6.08785659 L8.68684094,9.77469752 L9.77469752,8.68684094 L6.08785659,5 Z"></path> </svg> <span class="visually-hidden"> Remove filter </span> </span> </a>`;
            filterItem.addEventListener('click', removeFilterOption);
            activeFilterGroup.append(filterItem);
        });

        let removeFilters = document.createElement('li');
        removeFilters.classList.add('active-filter-group--remove-all', 'filter-item--grid-simple');
        removeFilters.innerHTML = `<a class="filter-item-clear-all"> Clear all </a>`;
        removeFilters.addEventListener('click', clearFilters);
        activeFilterGroup.append(removeFilters);

        setMobileFilterText();
    }
}

function removeFilterOption(e) {
    e.preventDefault();
    if(filter_form.classList.contains('loading')) return
    filter_form.classList.add('loading')
    let filterKey = this.getAttribute('data-filter-key');
    let filterValue = this.getAttribute('data-filter-value');
    let target = `${filterKey}_${encodeURIComponent(filterValue)}`;
    currentFilters = currentFilters.filter(item => item !== target);
    this.style.display = 'none';
    // console.log(currentFilters);
    localStorage.removeItem('klevuCollectionCachedInteraction');
    window.location.href = buildHref(1);
}

function clearFilters(e) {
    currentFilters = [];
    // console.log(currentFilters);
    localStorage.removeItem('klevuCollectionCachedInteraction');
    window.location.href = buildHref(1);
}

function mobileFilterButtonEvent() {
    mobile_filter_button.addEventListener('click',function(e){
        e.preventDefault();
        modalFirstGroupHeightInterval = setInterval(setModalFirstGroupHeight, 500);
    });
}

function setModalFirstGroupHeight() {
    let activeLists = document.querySelector('.modal--productgrid-filters')?.querySelectorAll('.productgrid--sidebar-button-active');
    if (activeLists) {
        activeLists.forEach((list)=>{
            let listElem = list.parentElement.querySelector('.collection-filters__filter-list');
            listElem.style.height = `${getHiddenHeight(listElem)}px`;
        });
        priceSlider.destroy();
        buildPriceSlider();
        if (currentFilters.length > 0) addClearAllButton();
        clearInterval(modalFirstGroupHeightInterval);
    }
}

function addClearAllButton() {
    let modalContent = document.querySelector('.modal-content');
    let mobileClearAll = document.createElement('a');
    mobileClearAll.classList.add('filter-item-clear-all', 'mobile-clear-all');
    mobileClearAll.innerText = 'Clear All';
    mobileClearAll.setAttribute('href', collection_url);
    mobileClearAll.addEventListener('click', showLoadingSpinner);
    modalContent.insertBefore(mobileClearAll, modalContent.querySelector('.filter-form'));
}

function setMobileFilterText() {
    mobile_filter_text.innerText = `Filters (${currentFilters.length})`;
}

function windowResizeEvent() {
    window.addEventListener('resize', function(e){
        if (priceSlider) {
            priceSlider.destroy();
            if (window.innerWidth < 860) {
                buildPriceSlider();
            }
            else {
                buildPriceSlider();
            }
        }
    });
}

/** currency conversion */

const arrayChunk = (arr, size) =>
    Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
    arr.slice(i * size, i * size + size)
);
